import React, { useState, useEffect } from "react";
import { Picker } from "emoji-mart";
import { usePubNub } from "pubnub-react";
import TextField from '@material-ui/core/TextField';
import Filesharing from '../filesharing'
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Chat,
} from "@pubnub/react-chat-components";
import "./simple-chat.scss";
import "emoji-mart/css/emoji-mart.css";
import Tooltip from '@material-ui/core/Tooltip';
import $ from 'jquery'
import { connect } from 'react-redux';
import Attach from '../../../img/videochat/attach2.svg'
import Send from '../../../img/videochat/Send2.svg'
import Smiliy from '../../../img/videochat/smily.svg'
import InputAdornment from '@material-ui/core/InputAdornment';
import moment from 'moment';

const listStyles = {
  alignItems: 'flex-start',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overflow: 'auto',
  padding: '10px',
  border: "1px solid #c4bfbf"
};

const messageStyles = {
  backgroundColor: '#eee',
  borderRadius: '5px',
  color: '#333',
  fontSize: '1rem',
  margin: '5px',
  padding: '4px 10px',
};

const fileStyles = {
  // backgroundColor: '#eee',
  borderRadius: '5px',
  color: '#333',
  fontSize: '1.1rem',
  margin: '5px',
  padding: '8px 15px',
};

 
function SimpleChat(props) {
  const pubnub = usePubNub(); //usePubNub is only used here to get current user info (as it's randomly selected)
  const [theme, setTheme] = useState("light");
  const [channel, setChannel] = useState([props.channel.name]);
  const [messages, addMessage] = useState([]);
  const [consolidatedData, setConsolidatedData] = useState([])
  const [message, setMessage] = useState('');
  const [showEmojis, setShowEmojis] = useState(false);
  const [progress, setProgress] = useState(false)

  useEffect(() => {
    setChannel([props.channel.name])
    addMessage([])
    console.log(props.channel, "channel")
    return () => {
      props.UpdateFormField({ name: "allchat", value: messages })
    }
  }, [props.channel.name])


   const formatDate = (dateString) => {
  const [day, month, year] = dateString.split('/').map(Number);
  const date = new Date(year, month - 1, day);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return 'Today';
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  } else {
    return moment(dateString, 'DD/M/YYYY').format('D MMM YYYY');
  }
};


  useEffect(() => {
    if (messages.length > 0) {

      const consolidatedMessages = messages.reduce((acc, message) => {
        const date = message.timestamp.split(',')[0];
        const existingDate = acc.find(item => item.timestamp === date);
        if (existingDate) {
          existingDate.data.push({ ...message, timestamp: message.timestamp.split(',')[1] });
        } else {
          acc.push({
            timestamp: date,
            data: [{ ...message, timestamp: message.timestamp.split(',')[1] }]
          });
        }
        return acc;
      }, []);

      console.log(consolidatedMessages, "consolidatedMessages");
      setConsolidatedData(consolidatedMessages)
    }else{
      setConsolidatedData([])
    }

  }, [messages])

  const showEmojisEvent = e => {
    e.preventDefault()
    setShowEmojis(!showEmojis)
  }
  const addEmoji = e => {
    let emoji = e.native;
    setMessage(message + emoji)
    setShowEmojis(!showEmojis)
    $("#outlined-textarea").focus();
  };

  const clientMessage = (publisher, message, time, metadata) => {
    // if (typeof message === 'string' || message.hasOwnProperty('text')) {
    const text = message.text || message;
    addMessage(messages => [...messages, { "publisher": publisher, "message": text, timestamp: time, metadata }]);
    // }
  };
  const addRemoteMsg = (publisher, message, time, metadata) => {
    addMessage(messages => [...messages, { "publisher": publisher, "message": message, timestamp: time, metadata }]);
  }
  function isValidJSON(data) {
    try {
      JSON.parse(data);
      return true;
    } catch (e) {
      return false;
    }
  }
  function isString(variable) {
    return typeof variable === "string";
  }
  function isStringified(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  useEffect(() => {
    pubnub.addListener({
      status: function (statusEvent) {
        if (statusEvent.category === "PNConnectedCategory") {
          console.log('join success with UID: ' + props.clientId);
        }
      },
      message: function (msg) {
        var msgg = msg?.message?.text ? isValidJSON(msg?.message?.text) ? JSON.parse(msg?.message?.text) : msg?.message?.text : JSON.parse(msg.message);
        const unixTimestamp = msg.timetoken / 10000000;
        const gmtDate = new Date(unixTimestamp * 1000);
        const localeDateTime = gmtDate.toLocaleString();
        if (msg?.publisher !== (props.clientId).toString()) {
          addRemoteMsg(msg.publisher, isString(msgg) ? msgg : "", localeDateTime, msg.userMetadata)
        } else {
          clientMessage(msg.publisher, isString(msgg) ? msgg : "", localeDateTime, msg.userMetadata)
        }
      },
      pnMessage: (pnMessage) => {
        // Handle push notification
      },
      presence: function (presenceEvent) {
        console.log('presence event: ' + JSON.stringify(presenceEvent));
      }
    })
    pubnub.subscribe({
      channels: channel, withPresence: true,
      // message: function(message) {
      //   new Notification('New Message', {
      //     body: message.text
      //   });
      // }
    });
    pubnub.history({
      channel: channel,
      count: 20,
      includeMeta: true
    }, (status, response) => {
      console.log(response, "response chat history")
      if (status.error) {
        console.log(status.error);
      } else {
        let data = response?.messages?.map((item, i) => {
          let obj = {
            message: isStringified(item?.entry.text) ? "" : item?.entry.text,
            metadata: item?.meta,
            "publisher": item?.meta?.id,
            "clientname": item?.meta?.name,
            timestamp: convertToLocalTime(item?.timetoken),

          }
          return obj
        })
        console.log(data, "history")
        if (response?.messages.length > 0 && data) {
          addMessage(data)
        } else {
          addMessage([])
        }
      }
    });
    //     pubnub.time((status, response) => {
    //   if (status.error) {
    //     console.log(status.error);
    //   } else {
    //     const currentTimeToken = response.timetoken;
    //     pubnub.deleteMessages({
    //       channel: 'my_channel',
    //       start: '0',
    //       end: currentTimeToken,
    //     }, (status, response) => {
    //       if (status.error) {
    //         console.log(status.error);
    //       } else {
    //         console.log(response,"ddl");
    //       }
    //     });
    //   }
    // });


  }, [pubnub, props.channel]);

  const convertToLocalTime = (value) => {
    const unixTimestamp = value / 10000000;
    const gmtDate = new Date(unixTimestamp * 1000);
    const localeDateTime = gmtDate.toLocaleString();
    return localeDateTime
  }

  // function publishMessage(message, callback) {
  //   var msgConfig = {
  //     channel: props.channel.name,
  //     sendByPost: true,
  //     message: {
  //       uuid: props.clientId,
  //       title: "text",
  //       description: message
  //     }
  //   }
  //   pubnub.publish(msgConfig, function (status, response) {
  //     console.log(status, response);
  //     if (callback != undefined && callback instanceof Function) {
  //       callback();
  //     }
  //   })
  // }

  const sendMessage = msg => {
    var message = isString(msg) ? msg : JSON.stringify(msg)
    // if (message.length > 0) {
    // if (message) {
    pubnub
      .publish({
        channel: channel[0], message: { text: message },
        meta: {
          name: props.channel.clientname,
          id: props.clientId,
          type: msg?.type ? msg.type : "message",
          url: msg?.url,
          attachmentName: msg?.name
        },
      })
      .then(() => setMessage(''))
    // .catch(error => {  // catch the errors
    //   console.log(error);
    // });
    // }
    // }
  }

  const handleInput = e => {
    setMessage(e.target.value)
  }

  const image = (name, url) => {
    return <span>{name}&nbsp;<img src={url} alt="image" height="75" width="75" /></span>

  }
  const imgClick = (e, url) => {
    e.preventDefault()
    window.open(url)
  }

  const downloadImg = (e, name, url, type) => {
    e.preventDefault()
    download(name, url, type)
  };
  const downloadPdf = (e, name, url, type) => {
    e.preventDefault()
    window.open(url)
    // download(name, url, type)
  }
  const downloadVideo = (e, name, url, type) => {
    e.preventDefault()
    window.open(url)
  }

  const download = (name, url, type) => {
    fetch(url, {
      method: "GET",
      headers: {}
    })
      .then(response => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", name); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch(err => {
        console.log(err);
      });

  };
  const loading = (status) => {
    setProgress(status)
  }
  // useEffect(() => {
  //   props.UpdateFormField({ name: "allchat", value: messages })
  // }, [messages])
  console.log(messages, "allmessages")
  return (
    <div className={`app-simple ${theme}`}>
      <Chat currentChannel={channel[0]} className="chat">
        <div className="card" style={{ width: "100%", borderRadius: "15px", border: "none" }}>
          <div className="card-header header" >
            {props.header ? props.header : "CHAT"}
          </div>
          <div className="card-body" style={listStyles}>
            {consolidatedData?.map((item, i) => (
              <>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                  <span style={{ color: "white", background: "grey", padding: "5px" }}>{formatDate(item.timestamp)}</span></div>

                {item.data?.map((message, index) => {
                  return (
                    <div key={`message-${index}`} className="mb-3">

                      <b>{message?.metadata?.name}</b>:

                      {message?.message == '' ?
                        <span style={fileStyles} className="cr">
                          {message?.metadata?.type?.includes("image")
                            ?
                            <a href={message.metadata.url} download
                              onClick={(e) => downloadImg(e, message.metadata.attachmentName, message.metadata.url, message.metadata.type)} target="_blank">{message.metadata.attachmentName}
                            </a>
                            :
                            message?.metadata?.type?.includes("pdf")
                              ?
                              <a href={message.metadata.url} download
                                onClick={(e) => downloadPdf(e, message.metadata.attachmentName, message.metadata.url, message.metadata.type)} target="_blank">{message.metadata.attachmentName}
                              </a>
                              : message?.metadata?.type?.includes("video")
                                ?
                                <a href={message.metadata.url} download
                                  onClick={(e) => downloadVideo(e, message.metadata.attachmentName, message.metadata.url, message.metadata.type)} target="_blank">{message.metadata.attachmentName}</a>
                                : ""}
                        </span>
                        : <span style={messageStyles}>{message.message}</span>}
                      <span style={{ fontSize: "10px", color: "#cccbcc" }}> {message.timestamp}</span>
                    </div>
                  );
                })}</>
            ))}
          </div>
          <div className="card-footer chatfooter">
            <TextField
              id="outlined-textarea"
              // label="Multiline"
              multiline
              rows={1}
              maxRows={4}
              fullWidth
              clientName={props.channel.clientname}
              value={message}
              variant="outlined"
              onKeyPress={e => {
                if (e.key !== 'Enter') return;
                sendMessage(message);
              }}
              onChange={e => handleInput(e)}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <img src={Smiliy} alt="emojis" onClick={e => showEmojisEvent(e)} style={{ color: "#23416F", cursor: "pointer", marginRight: "5px" }} />
                    {/* <Divider style={dividerStyles} orientation="vertical" /> */}
                    {progress ? <CircularProgress color="inherit" size={25} style={{ marginTop: "9px", marginLeft: "5px" }} /> : <>
                      {/* <Tooltip title="Send Files" arrow> */}
                      <Filesharing text={
                        <img src={Attach} alt="Attachments" loading={false} style={{ color: "#23416F", cursor: "pointer" }} />
                        // <i className="fas fa-paperclip" style={{ color: "#23416F", fontSize: "15px", padding: "9px" }} loading={false}></i>
                      } dataToAccept='image/*,video/*,.pdf,.xlsx,.txt,.xls,.ppt,.pptx,.doc,.docx' type="Document" sendMessage={sendMessage} loading={loading} />
                      {/* </Tooltip> */}
                    </>}
                  </InputAdornment>,
              }}
            />
            {showEmojis && (
              <span className="emojiPicker">
                <Picker
                  onSelect={addEmoji}
                  emojiTooltip={true}
                  title="weChat"
                />
              </span>
            )}
            {/* <p className="getEmojiButton" onClick={e => showEmojisEvent(e)}>
              {String.fromCodePoint(0x1f60a)}
            </p> */}
            {/* <Tooltip title="Send" arrow> */}
            {message.trim().length !== 0 && <img src={Send} alt="send" onClick={e => {
              e.preventDefault();
              sendMessage(message);
            }} style={{ margin: "5px", cursor: "pointer" }} />}
            {/* <i className="fas fa-paper-plane" style={{ color: "#23416F", fontSize: "15px", padding: "9px" }} onClick={e => {
              e.preventDefault();
              sendMessage(message);
            }}></i> */}
            {/* </Tooltip> */}
          </div>
        </div>
      </Chat>

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SimpleChat);
